import { FriendSentListProps } from "./type"
import React from "react"
import { FriendSentListCore } from "./core"

const FriendSentList: React.FC<FriendSentListProps> = ({
  sections,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  return (
    <FriendSentListCore
      sections={sections}
      swipeActionButtonConfigs={swipeActionButtonConfigs}
      onItemClick={onItemClick}
      selecteds={selecteds}
    ></FriendSentListCore>
  )
}

export default FriendSentList
